import { ReactNode } from 'react';
import { Color } from 'src/utils/theme';
import * as S from './styles';

type Props = {
  backgroundColor: Color;
  invertTextColor?: boolean;
  title: ReactNode;
  description: ReactNode;
  children?: ReactNode;
};

export const SideNoteBlock = ({
  title,
  description,
  children,
  backgroundColor,
  invertTextColor,
}: Props) => (
  <S.Container $backgroundColor={backgroundColor} $invertTextColor={invertTextColor}>
    <S.Content>
      <S.Title>{title}</S.Title>
      <S.Description>{description}</S.Description>
      {children}
    </S.Content>
  </S.Container>
);
